import { createSlice } from "@reduxjs/toolkit";
import { FloorCleanerProduct } from "../../Api/Api"; // Import API function

const floorCleanerSlice = createSlice({
    name: "floorCleaner",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(FloorCleanerProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(FloorCleanerProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(FloorCleanerProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default floorCleanerSlice.reducer;
